module.exports = __webpack_public_path__ + "img/inspect_0 - 副本.d640295d.png";